module.exports = __webpack_public_path__ + "static/media/26.941a1f3b.jpg";